import React, { useContext, useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getInitials, StaticUploadPath } from '../shared/shared';
import { UserContext } from '../../utils/UserContext';
import { logout } from '../../utils/Logout';



const ProfileOverlay = () => {
  const navigate = useNavigate();
  const { datauser } = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
    <Box
  onClick={handleClick}
  sx={{
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    px: 1.5,
    py: 0.5,
    borderRadius: 2,
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  }}
>
  <Avatar
    src={`${StaticUploadPath}/${datauser.profile_image}`}
    alt={datauser.username}
    sx={{ width: 32, height: 32, fontSize: 14, mr: 1 }}
  >
    {getInitials(datauser.username)}
  </Avatar>
  <Box sx={{ textAlign: 'left', display: { xs: 'none', md: 'block' } }}>
    <Typography variant="subtitle1" sx={{ m: 0, lineHeight: 1.2 }}>
      {datauser.username}
    </Typography>
    <Typography variant="subtitle2"  sx={{ m: 0, lineHeight: 1.2, color: "#D6C3B0" }}>
      {datauser?.role||""}
    </Typography>
  </Box>
</Box>


      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ autoFocusItem: false }}
      >
        <MenuItem  onClick={
          () => {navigate('/viewprofile');
            setAnchorEl(null)
          }

        }>View Profile</MenuItem>
        <MenuItem onClick={handleClose}>Reset Password</MenuItem>
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default ProfileOverlay;
